import type { TermsSettings, TicketBookingPolicy } from "./types";

/**
 * Constructs a TicketBookingPolicy from school-level TermsSettings.
 * Used as a fallback when a ticket doesn't have its own resolved bookingPolicy.
 */
export function buildFallbackBookingPolicy(
  termsSettings?: TermsSettings,
): TicketBookingPolicy | null {
  if (!termsSettings) return null;

  const { cancellationPolicy, reschedulePolicy } = termsSettings;
  if (!cancellationPolicy && !reschedulePolicy) return null;

  return {
    id: "school-default",
    name: "Cancellation Policy",
    canCancel: cancellationPolicy?.canCancel ?? false,
    cancellationTiers: (cancellationPolicy?.cancellationTiers ?? []).map(
      (tier) => ({
        daysBefore: tier.daysBefore,
        hoursBefore: tier.hoursBefore,
        refundPercentage: tier.refundPercentage,
      }),
    ),
    canReschedule: reschedulePolicy?.canReschedule ?? false,
    rescheduleDaysBefore: reschedulePolicy?.rescheduleDaysBefore ?? 0,
    rescheduleHoursBefore: reschedulePolicy?.rescheduleHoursBefore ?? 0,
    additionalTerms: null,
  };
}
